import { Context } from "../../../core/impl/Context";
import { NetworkInstancesManager } from "../../../networkinstances/impl/manager/NetworkInstancesManager";
import { NetworkInstance } from "../../../networkinstances/impl/model/NetworkInstance";
import { Country } from "../model/Country";
import { filterCountriesByCountryCode } from "./CountryFilters";

import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger("WorldAssignment.CountryUtils");

/**
 * Returns a GGS Country Code of the country predefined by instanceId defined by query string.
 */
export const getCountryCodeByPresetInstance = (presetInstanceId: number): string => {
    const instanceManager: NetworkInstancesManager = Context.instance.get(NetworkInstancesManager);

    if (!instanceManager) {
        logger.error("getCountryCodeByPreselectedInstance: NetworkInstancesManager not initialized");
        return;
    }

    if (presetInstanceId > 0) {
        let instance: NetworkInstance = instanceManager.getInstanceById(presetInstanceId);
        if (instance && instance.countries) {
            //
            if (instance.countries.length == 1) {
                return instance.countries[0].ggsCountryCode;
            }
            else {
                logger.warn("getCountryCodeByPreselectedInstance: found an instance for the presetInstanceID but could not determine Country because there are more than one,  following steps in CountryDetection will  find the right one")
            }
        } else {
            logger.error("getCountryCodeByPreselectedInstance: unable to select instance by preset instanceId, wrong network.xml?");
        }
    }
};

/**
 * Returns a GGS Country Code of the country predefined by friend invite code.
 */
export const getCountryCodeByFriendInvite = (friendInviteZoneId: number, friendInviteCountryCode: string): string => {
    const instanceManager: NetworkInstancesManager = Context.instance.get(NetworkInstancesManager);

    if (!instanceManager) {
        logger.error("getCountryCodeByFriendInvite: NetworkInstancesManager not initialized");
        return;
    }

    if (friendInviteZoneId > 0) {
        let instance: NetworkInstance = instanceManager.getInstanceByZoneId(friendInviteZoneId);

        if (instance && instance.countries) {
            let countriesByLanguage: Country[] = filterCountriesByCountryCode(instance.countries, friendInviteCountryCode);

            if (countriesByLanguage.length) {
                return countriesByLanguage[0].ggsCountryCode;
            } else {
                return instance.countries[0].ggsCountryCode;
            }
        } else {
            logger.error("getCountryCodeByFriendInvite: instance provided by friend invite code is not valid");
        }
    }
};

/**
 * Returns a GGS Country Code of the country predefined network settings.
 */
export const getCountryCodeByDefaultInstance = (defaultInstanceId: number): string => {
    const instanceManager: NetworkInstancesManager = Context.instance.get(NetworkInstancesManager);

    if (!instanceManager) {
        logger.error("getCountryCodeByDefaultInstance: NetworkInstancesManager not initialized");
        return;
    }

    let instance: NetworkInstance = instanceManager.getInstanceById(defaultInstanceId);

    if (instance && instance.defaultcountry) {
        return instance.defaultcountry;
    } else {
        logger.error("getCountryCodeByDefaultInstance: unable to select instance by default instance, wrong network.xml?");
    }
};
